<template>
  <el-main class="main" style="height: calc(100vh - 56px - 20px)">
    <el-col :span="12" class="item">
      <el-card class="box-card" shadow="hover" body-style="padding: 10px;">
        <div class="card-header">
          <span class="title"><i class="fa fa-navicon"></i>&nbsp;卡片名称</span>
          <!-- <el-button style="float: right; padding: 3px 0" type="text">操作按钮</el-button> -->
        </div>
        <div v-for="o in 4" :key="o" class="card-content">
          {{'列表内容 ' + o }}
        </div>
      </el-card>
    </el-col>
    <el-col :span="12" class="item">
      <el-card class="box-card" shadow="hover" body-style="padding: 10px;">
        <div class="card-header">
          <span class="title"><i class="fa fa-navicon"></i>&nbsp;卡片名称</span>
          <!-- <el-button style="float: right; padding: 3px 0" type="text">操作按钮</el-button> -->
        </div>
        <div v-for="o in 4" :key="o" class="card-content">
          {{'列表内容 ' + o }}
        </div>
      </el-card>
    </el-col>
    <el-col :span="12" class="item">
      <el-card class="box-card" shadow="hover" body-style="padding: 10px;">
        <div class="card-header">
          <span class="title"><i class="fa fa-navicon"></i>&nbsp;卡片名称</span>
          <!-- <el-button style="float: right; padding: 3px 0" type="text">操作按钮</el-button> -->
        </div>
        <div v-for="o in 4" :key="o" class="card-content">
          {{'列表内容 ' + o }}
        </div>
      </el-card>
    </el-col>
    <el-col :span="12" class="item">
      <el-card class="box-card" shadow="hover" body-style="padding: 10px;">
        <div class="card-header">
          <span class="title"><i class="fa fa-navicon"></i>&nbsp;卡片名称</span>
          <!-- <el-button style="float: right; padding: 3px 0" type="text">操作按钮</el-button> -->
        </div>
        <div v-for="o in 4" :key="o" class="card-content">
          {{'列表内容 ' + o }}
        </div>
      </el-card>
    </el-col>
  </el-main>
</template>

<script>
export default {
  data () {
    return {
    }
  },
  created () {
  },
  methods: {
  }
}
</script>

<style scoped>
@import '../../../assets/manage-index.css';
</style>



// WEBPACK FOOTER //
// src/components/manage-components/index/Index.vue